export default __webpack_public_path__ + "static/media/info-red.cbe5559f.png";